import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {Image} from "../../data/models/image";

/**
 * Diese Direktive überprüft, ob HTML-Elemente valide Werte (d.h. != null && != '' && != undefined) beinhalten:
 * wenn der Wert valide ist, wird das Element gerendert, sonst wird es aus dem DOM entfernt.
 * Grund dafür: Assistive Gadgets wie z. B. Screenreaders etc. lesen leere HTML-Elemente falsch vor.
 */
@Directive({
  selector: '[appApplyIfNotEmpty]'
})
export class ApplyIfNotEmptyDirective {

  /**
   * Steht das Element schon im DOM? Wechselt der Wert von einem gültigen zum nächsten gültigen
   * (z. B. Singular- zu Plural-Text), darf es nicht ein zweites Mal gerendert werden - die
   * Bindungen im Element zeigen den neuen Wert ohnehin.
   */
  private hasView = false;

  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainer: ViewContainerRef
  ) {
  }

  @Input('appApplyIfNotEmpty') set appApplyIfNotEmpty(value: string | null | undefined | Image) {
    if (typeof value === 'string' && value.trim() || (value instanceof Image && value.type)) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
